import actions from '~/store/modules/shared/notification/topic/subscription/actions'
import getters from '~/store/modules/shared/notification/topic/subscription/getters'
import mutations from '~/store/modules/shared/notification/topic/subscription/mutations'
import state from '~/store/modules/shared/notification/topic/subscription/state'
import { createModule } from '~/factories/store'

export default createModule({
  actions,
  getters,
  mutations,
  state
})
